<template>
  <BaseView :onScroll="onScroll">
    <template #header>
      <SearchRouteComponent />
    </template>

    <template #content>
      <EmptyRoutes v-if="requestFailed" message="Could not fetch routes" />
      <EmptyRoutes v-else-if="noRoutes" message="No routes found" />
      <RoutesLoading v-else-if="fetchLoading" />
      <RoutesSuccess v-else />
    </template>

    <template #snackbar>
      <RequestResponseSnackBar
        :value="showErrorSnackBar"
        v-model="showErrorSnackBar"
        :text="deleteError"
        color="red"
        :timeout="3000"
      />
    </template>

    <template #action>
      <CustomThemedButton
        rounded
        block
        class="main-button"
        @click="onCreateRoutePressed"
      >
        Create Route
      </CustomThemedButton>
    </template>
  </BaseView>
</template>
  <script>
import { mapGetters, mapState } from "vuex";
import RoutesSuccess from "./SuccessView.vue";
import RoutesLoading from "./LoadingView.vue";
import EmptyRoutes from "./components/EmptyList.vue";
import SearchRouteComponent from "./components/SearchRouteComponent.vue";
import BaseView from "../../components/BaseView.vue";
import RequestResponseSnackBar from "../../components/RequestResponseSnackBar.vue";
import CustomThemedButton from "@/core/CustomThemedButton.vue";
export default {
  name: "Routes",
  data: function () {
    return {
      showErrorSnackBar: false,
    };
  },
  components: {
    RoutesSuccess,
    EmptyRoutes,
    RoutesLoading,
    SearchRouteComponent,
    RequestResponseSnackBar,
    BaseView,
    CustomThemedButton,
  },
  computed: {
    ...mapState("weatherRouting/routesModule", [
      "fetchLoading",
      "fetchError",
      "deleteError",
    ]),
    ...mapGetters("weatherRouting/routesModule", [
      "requestFailed",
      "deleteRequestFailed",
      "noRoutes",
    ]),
  },
  methods: {
    onScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        this.$store.dispatch(
          "weatherRouting/routesModule/paginatedFetchAllRoutes"
        );
      }
    },
    onCreateRoutePressed() {
      this.$router.push({
        name: "Create Route",
      });
      this.$store.commit(
        "weatherRouting/routesModule/SET_SELECTED_ROUTE",
        null
      );
    },
  },
  watch: {
    deleteRequestFailed: {
      handler(value) {
        this.showErrorSnackBar = value;
      },
      deep: true,
    },
  },
};
</script>
  
  <style scoped>
.v-card-title {
  font-size: 1rem;
}
.text--secondary {
  margin-top: -4px;
}
.main-button {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}
</style>